export const PERCENT_INPUT_HTML_SIZE = 2;
